<template>
	<div class="col-12 col-lg-4">
		<b-form-group id="example-input-group-4" description="">
			<label for="example-input-group-4" class="d-block col-form-label-sm">Email</label>
			<b-form-input
				type="email"
				:value="value"
				:state="isValidate"
				@input="$emit('input', $event)"
				@change="$emit('change', $event)"
				@blur="onBlur"
			/>
			<b-form-invalid-feedback id="input-4-live-feedback">
				Поле обязательно для заполнения
			</b-form-invalid-feedback>
		</b-form-group>
	</div>
</template>

<script>
export default {
	name: 'StringInput',
	props: {
		field: {
			type: Object,
			default: () => {
			},
		},
		value: { type: String, default: null },
	},
	data() {
		return {
			isValidate: null,
		};
	},
	methods: {
		/**
		 * Проверяем валидность по библиотеке vuelidate
		 * @param form Oбъект, сгенерированный vuelidate, содержит инфу об ошибках
		 */
		checkValidation(form) {
			if (this.validEmail(this.value)) {
				this.isValidate = typeof form[this.field.slug]?.$error !== 'undefined' ? !form[this.field.slug]?.$error : true;
			} else this.isValidate = false;
			return this.isValidate;
		},
		validEmail(email) {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},
		onBlur() {
			this.$emit('blur', this.value, this.isValidate);
		},
	},
};
</script>

<style scoped>

</style>
